export default __webpack_public_path__ + "static/home@2x-f314fb05f109ae99ac7f3cd6a751a301.jpg";